/*参观服务-子路由*/
export default [
  {
    path: '/service/questionnaire',
    name: 'questionnaire',
    component: resolve => require(['@/components/service/questionnaire/index.vue'], resolve),
    meta: {
      title: '问卷调查'
    }
  },
  {
    path: '/service/yaoyiyao',
    name: 'yaoyiyao',
    component: resolve => require(['@/components/service/yaoyiyao/index.vue'], resolve),
    meta: {
      title: '摇一摇'
    }
  },
  {
    path: '/service/opinion',
    name: 'opinion',
    component: resolve => require(['@/components/service/opinion/index.vue'], resolve),
    meta: {
      title: '意见反馈',
      needLogin: true
    }
  },
  {
    path: '/service/activity_yy',
    name: 'activity_yy',
    component: resolve => require(['@/components/service/activity_yy/index.vue'], resolve),
    redirect: '/service/activity_yy/list',
    meta: {
      title: '活动预约',
      needLogin: true
    },
    children: [
      {
        path: '/service/activity_yy/list',
        name: 'activity_yy',
        component: resolve => require(['@/components/service/activity_yy/list.vue'], resolve),
        meta: {
          title: '活动预约',
          needLogin: true
        }
      },
      {
        path: '/service/activity_yy/detail/:id',
        name: 'activity_detail',
        component: resolve => require(['@/components/service/activity_yy/detail.vue'], resolve),
        meta: {
          title: '活动预约详情',
          needLogin: true
        }
      },
      {
        path: '/service/activity_yy/order',
        name: 'activity_order',
        component: resolve => require(['@/components/service/activity_yy/order.vue'], resolve),
        meta: {
          title: '活动预约报名',
          needLogin: true
        }
      }
    ]
  },
  {
    path: '/service/order/index',
    name: 'order_index',
    component: resolve => require(['@/components/service/order/index.vue'], resolve),
    redirect: '/service/order/entry',
    meta: {
      title: '门票预约',
      needLogin: true
    },
    children: [
      {
        path: '/service/order/entry',
        name: 'order_entry',
        component: resolve => require(['@/components/service/order/entry.vue'], resolve),
        meta: {
          title: '个人门票预约',
          needLogin: false
        }
      },
      {
        path: '/service/order/teamEntry',
        name: 'order_teamEntry',
        component: resolve => require(['@/components/service/order/teamEntry.vue'], resolve),
        meta: {
          title: '团队门票预约',
          needLogin: false
        }
      }
    ]
  },
  {
    path: '/service/order/sureEntry',
    name: 'sureEntry',
    component: resolve => require(['@/components/service/order/sureEntry.vue'], resolve),
    props: {},
    meta: {
      title: '信息确认'
    }
  },
  {
    path: '/service/order/sureTeamEntry',
    name: 'sureTeamEntry',
    component: resolve => require(['@/components/service/order/sureTeamEntry.vue'], resolve),
    props: {},
    meta: {
      title: '信息确认'
    }
  },
  {
    path: '/service/order/placeOrder',
    name: 'placeOrder',
    component: resolve => require(['@/components/service/order/placeOrder.vue'], resolve),
    meta: {
      title: '车位预约'
    }
  },
  {
    path: '/service/order/explainOrder',
    name: 'explainOrder',
    component: resolve => require(['@/components/service/order/explainOrder.vue'], resolve),
    meta: {
      title: '讲解预约'
    }
  }
]


// WEBPACK FOOTER //
// ./src/router/service/index.js